<template>
  <div class="card">
    <Toolbar>
      <template #start>
        <div class="field">
          <label for="projeto">Projeto</label><br />
          <Dropdown
            id="projeto"
            v-model="selectedProject"
            :options="projects"
            optionLabel="name"
            placeholder="Selecione um projeto"
            @change="findFoldersByProjectId(selectedProject.id)"
            filter="true"
          />
        </div>
        <i class="pi pi-arrow-right mt-2 ml-2 mr-2" style="font-size: 1rem"></i>
        <div class="field">
          <label for="diretorio">Diretório</label><br />
          <Dropdown
            id="diretorio"
            v-model="selectedFolder"
            :options="folders"
            optionLabel="subDirectory"
            placeholder="Selecione um diretório"
            @change="findFilesByFolderId()"
            filter="true"
          />
        </div>
      </template>
    </Toolbar>
    <br />
    <DataTable
      :value="files"
      :lazy="true"
      :paginator="true"
      :rows="10"
      :rowsPerPageOptions="[10, 15, 20]"
      ref="dt"
      class="p-datatable-sm"
      dataKey="id"
      :totalRecords="totalRecords"
      :loading="loading"
      @page="onPage($event)"
      paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
      currentPageReportTemplate="Exibindo de {first} a {last} no total de {totalRecords} arquivos."
    >
      <template #header>
        <div
          class="flex flex-wrap align-items-center justify-content-between gap-2"
        >
          <span class="text-xl text-900 font-bold">LISTA DE ARQUIVOS</span>
          <div>
            <Button
              v-if="openNew"
              icon="pi pi-plus"
              label="Novo"
              class="p-button-success mr-2"
              @click="showCreate"
              v-tooltip.top="'CLIQUE PARA UM NOVO ARQUIVO'"
            />
          </div>
        </div>
      </template>
      <template #empty>
        <div class="text-center">Nenhum resultado encontrado...</div>
      </template>
      <Column>
        <template #body="slotProps">
          <div
            v-if="
              slotProps.data.type === 'png' ||
              slotProps.data.type === 'jpg' ||
              slotProps.data.type === 'jpeg'
            "
          >
            <img
              class="img-fluid img-thumbnail"
              :src="getUrl(slotProps.data)"
              width="70"
              height="70"
            />
          </div>
          <div v-else-if="slotProps.data.type === 'pdf'">
            <i
              class="pi pi-file-pdf ml-3"
              style="font-size: 2.5rem; color: red"
            ></i>
          </div>
          <div v-else>
            <i class="pi pi-file ml-3" style="font-size: 2.5rem"></i>
          </div>
        </template>
      </Column>
      <Column field="name" header="Nome do Arquivo">
        <template #body="slotProps">
          {{ slotProps.data.name }}
        </template>
      </Column>
      <Column field="type" header="Tipo">
        <template #body="slotProps">
          {{ slotProps.data.type }}
        </template>
      </Column>
      <Column field="size" header="Tamanho">
        <template #body="slotProps">
          {{ converterBits(slotProps.data.size) }}
        </template>
      </Column>
      <Column field="dtCreate" header="Criado em">
        <template #body="slotProps">
          {{ $DateTime.formatarDateTime24hours(slotProps.data.dtCreate) }}
        </template>
      </Column>
      <Column field="dtUpdate" header="Atualizado em">
        <template #body="slotProps">
          <div v-if="slotProps.data.dtUpdate">
            {{ $DateTime.formatarDateTime24hours(slotProps.data.dtUpdate) }}
          </div>
          <div v-else>Sem Atualização</div>
        </template>
      </Column>
      <Column field="pathFile" header="Caminho">
        <template #body="slotProps">
          {{ slotProps.data.pathFile }}
        </template>
      </Column>
      <Column header="Ações">
        <template #body="slotProps">
          <Button
            icon="pi pi-eye"
            class="p-button-rounded mr-2"
            @click="preview(slotProps.data)"
            v-tooltip.top="'CLIQUE PARA VIZUALIZAR'"
            v-if="
              slotProps.data.type === 'png' ||
              slotProps.data.type === 'jpg' ||
              slotProps.data.type === 'jpeg' ||
              slotProps.data.type === 'pdf'
            "
          />
          <Button
            icon="pi pi-cloud-download"
            class="p-button-rounded p-button-secondary mr-2"
            @click="download(slotProps.data)"
            v-tooltip.top="'CLIQUE PARA DOWNLOAD'"
          />

          <Button
            icon="pi pi-pencil"
            class="p-button-rounded p-button-success mr-2"
            @click="showUpdate(slotProps.data)"
            v-tooltip.top="'CLIQUE PARA ATUALIZAR'"
          />
          <Button
            icon="pi pi-trash"
            class="p-button-rounded p-button-warning"
            @click="showRemove(slotProps.data)"
            v-tooltip.top="'CLIQUE PARA EXCLUIR'"
          />
        </template>
      </Column>
    </DataTable>
  </div>
  <ConfirmDialog></ConfirmDialog>
  <dialog-form
    :selected="file"
    :selectedFolder="folder"
    @findAll="findFilesByFolderId()"
  />
</template>

<script>
//models
import Project from "../../models/project";
import Folder from "../../models/folder";
import File from "../../models/file";

//Services
import ProjectService from "../../service/project/project_service";
import FolderService from "../../service/folder/folder_service";
import FileService from "../../service/file/file_service";

//components
import DialogForm from "./components/dialog-form.vue";
export default {
  components: {
    DialogForm,
  },
  data() {
    return {
      selectedProject: "",
      project: new Project(),
      projects: [],
      projectService: new ProjectService(),

      selectedFolder: "",
      folder: new Folder(),
      folders: [],
      folderService: new FolderService(),

      file: new File(),
      files: [],
      fileService: new FileService(),

      lazyParams: {},
      totalRecords: 0,
      loading: false,
      openNew: false,
    };
  },
  created() {
    this.findProjects();
  },
  mounted() {
    this.lazyParams = {
      first: 0,
      rows: this.$refs.dt.rows,
      sortField: null,
      sortOrder: null,
      name: "",
      type: "",
      folderId: "",
    };
  },
  methods: {
    showCreate() {
      this.project = this.selectedProject;
      this.folder = this.selectedFolder;
      this.file = new File();
      this.$store.state.views.file.dialogForm = true;
    },
    showCompress() {
      this.project = this.selectedProject;
      this.folder = this.selectedFolder;
      this.file = new File();
      this.$store.state.views.file.dialogForm = true;
    },
    showCropper() {
      this.project = this.selectedProject;
      this.folder = this.selectedFolder;
      this.file = new File();
      this.$store.state.views.file.dialogForm = true;
    },
    showCompressAndCropper() {
      this.project = this.selectedProject;
      this.folder = this.selectedFolder;
      this.file = new File();
      this.$store.state.views.file.dialogForm = true;
    },
    showUpdate(file) {
      this.project = this.selectedProject;
      this.folder = this.selectedFolder;
      this.file = file;
      this.$store.state.views.file.dialogForm = true;
    },
    showRemove(file) {
      this.file = file;
      this.$confirm.require({
        message: "Deseja excluir esse projeto?",
        header: "Deseja deletar?",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sim",
        rejectLabel: "Não",
        accept: () => {
          this.fileService
            .remove(this.file.hashKey)
            .then((data) => {
              this.$msgSuccess(data);
              this.findFilesByFolderId();
            })
            .catch((err) => {
              this.loading = false;
              this.$toast.add({
                severity: "error",
                summary: "Alerta de Erro.",
                detail: err,
                life: 6000,
              });
            });
        },
      });
    },
    findProjects() {
      this.projectService.findAll().then((data) => {
        this.projects = data;
      });
    },
    findFoldersByProjectId(projectId) {
      this.folderService.findfoldersByProjectId(projectId).then((data) => {
        this.folders = data;
        this.files = [];
        this.openNew = false;
      });
    },
    findFilesByFolderId() {
      this.loading = true;
      this.lazyParams.folderId = this.selectedFolder.id;
      this.fileService.findFilesByFolderId(this.lazyParams).then((data) => {
        this.files = data.content;
        this.totalRecords = data.totalElements;
        this.loading = false;
        this.openNew = true;
      });
    },
    getUrl(file) {
      return this.fileService.urlImg(file);
    },
    converterBits(x) {
      const units = ["bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
      let l = 0,
        n = parseInt(x, 10) || 0;

      while (n >= 1024 && ++l) {
        n = n / 1024;
      }
      return n.toFixed(n < 10 && l > 0 ? 1 : 0) + " " + units[l];
    },
    download(file) {
      this.fileService.download(file.hashKey).then((response) => {
        if (response.status == 200) {
          let blob = new Blob([response.data], {
            type: response.headers["content-type"],
          });
          let downloadUrl = URL.createObjectURL(blob);
          let a = document.createElement("a");
          //a.style.display = "none";
          a.href = downloadUrl;
          a.download = file.name;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(downloadUrl);
        }
      });
    },
    preview(file) {
      this.fileService.preview(file.hashKey);
    },
    onPage(event) {
      this.lazyParams.first = event.originalEvent.first;
      this.lazyParams.page = event.originalEvent.page;
      this.lazyParams.size = event.rows;
      this.findFilesByFolderId();
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("../../App.scss");
.product-image {
  width: 100px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}
</style>
